export type SuggestTransitionVariant = 'enter' | 'exit';
export type SuggestTransitionPhase = 'in' | 'out';

interface Props {
  variant: SuggestTransitionVariant;
  phase: SuggestTransitionPhase;
}

/**
 * Full-viewport overlay that covers the page while ClientReview swaps into
 * or out of suggest mode underneath it — see enterSuggestMode/
 * exitSuggestMode in ClientReview.tsx for the choreography. Momentary and
 * decorative (the meaningful state change is the page underneath), so it's
 * hidden from assistive tech and from print. Never rendered under
 * prefers-reduced-motion — the caller skips it entirely in that case.
 */
export default function SuggestModeTransition({ variant, phase }: Props) {
  return (
    <div
      aria-hidden
      data-print-hide
      className={`suggest-transition suggest-transition--${variant} suggest-transition--${phase}`}
    >
      <div className="suggest-transition__copy">
        <span className="suggest-transition__eyebrow" style={{ animationDelay: '40ms' }}>
          {variant === 'enter' ? '// Suggest mode' : '// Review mode'}
        </span>
        {variant === 'enter' && (
          <span className="suggest-transition__line" style={{ animationDelay: '140ms' }}>
            Opening your editing space
          </span>
        )}
      </div>
    </div>
  );
}
